/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { defineMessages } from 'react-intl';

export const BasicSetup = defineMessages({
  title: {
    id: 'whatsapp.BasicSetup.title',
    defaultMessage: 'Twilio account information'
  },
  subtitle: {
    id: 'whatsapp.BasicSetup.subtitle',
    defaultMessage:
      'WhatsApp integration requires Twilio, see setup details below, and <link>find your credentials on Twilio</link>.'
  },
  webhookHeader: {
    id: 'whatsapp.BasicSetup.webhookHeader',
    defaultMessage: 'Webhook'
  },
  webhookDescription: {
    id: 'whatsapp.BasicSetup.webhookDescription',
    defaultMessage:
      'Copy the uniquely generated webhook below and provide to Twilio. This will allow messages to be sent and received through WhatsApp.'
  },
  webhookLabel: {
    id: 'whatsapp.BasicSetup.webhookLabel',
    defaultMessage: 'WhatsApp webhook'
  },
  instructions: {
    id: 'whatsapp.BasicSetup.instructions',
    defaultMessage: 'Setup instructions'
  },
  instructionsDescription: {
    id: 'whatsapp.BasicSetup.instructionsDescription',
    defaultMessage: "For this integration to work, here's what you need to do:"
  },
  instructionsItemOne: {
    id: 'whatsapp.BasicSetup.instructionsItemOne',
    defaultMessage:
      'Create a Twilio account to setup a basic integration when using WhatsApp. Once authorized, you can start assigning that assistant to conversations.'
  },
  instructionsItemTwo: {
    id: 'whatsapp.BasicSetup.instructionsItemTwo',
    defaultMessage:
      "To start using the Twilio API for WhatsApp, you'll need to enable Twilio numbers with your Facebook Business Manager ID to initiate a request."
  },
  instructionsLinkFacebookText: {
    id: 'whatsapp.BasicSetup.instructionsLinkFacebookText',
    defaultMessage: 'Facebook Business Manager ID'
  },
  instructionsLinkFacebook: {
    id: 'whatsapp.BasicSetup.instructionsLinkFacebook',
    defaultMessage: '<link>Facebook Business Manager ID</link>'
  },
  instructionsLinkTwilio: {
    id: 'whatsapp.BasicSetup.instructionsLinkTwilio',
    defaultMessage: '<link>Twilio API for WhatsApp</link>'
  },
  instructionsLinkTwilioText: {
    id: 'whatsapp.BasicSetup.instructionsLinkTwilioText',
    defaultMessage: 'Twilio API for WhatsApp'
  },
  generateCallbackUrl: {
    id: 'whatsapp.BasicSetup.generateCallbackUrl',
    defaultMessage: 'Generate callback URL'
  }
});
